import * as React from 'react';
import { View } from 'react-native';
import theme from '../../../util/theme';

const Spacer = () => <View style={{ height: theme.spacing(3) }} />

export default Spacer
